export default __webpack_public_path__ + "static/venti_abierto-14abe3fb8085346044809146ede0584e.png";